import { render, staticRenderFns } from "./HiboLateralPanel.vue?vue&type=template&id=4c78b7ee&"
import script from "./HiboLateralPanel.vue?vue&type=script&lang=ts&"
export * from "./HiboLateralPanel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports